import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://burger-builder-eca62.firebaseio.com/'
});

export default instance;